/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_SpeakersInputs */



/**
* | output |
* | --- |
* | "Include Speakers" |
*
* @param {Transcript_Export_Include_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_speakers = /** @type {((inputs?: Transcript_Export_Include_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure les intervenants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher einbeziehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить докладчиков")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包括演讲者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं को शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir palestrantes")
	return /** @type {LocalizedString} */ ("Include Speakers")
});